import { render, staticRenderFns } from "./flats-crm-filter-desctop.vue?vue&type=template&id=4be26825"
import script from "./flats-crm-filter-desctop.vue?vue&type=script&lang=js"
export * from "./flats-crm-filter-desctop.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-filter-desctop.vue?vue&type=style&index=0&id=4be26825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports